export default {
  namespaced: true,

  state: {
    visible: false
  },

  getters: {
    isVisible: (state) => state.visible
  },

  mutations: {
    isVisable(state) {
      state.visible = true
    },

    isHidden(state) {
      state.visible = false
    },

    resetState(state) {
      state.visible = false
    }
  },

  actions: {
    show({ commit }) {
      commit('isVisable')
    },

    hide({ commit }) {
      commit('isHidden')
    }
  }
}
